<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Modal
    title="编辑咨询"
    :closable="false"
    v-model="modalShowHide"
    @on-hidden="onHidden"
    :width="700"
    class="modal-setting"
    class-name="vertical-center-modal"
  >
    <ul class="o-y-auto w-full p-h-10" style="max-height: 600px">
      <li :key="index" style="background-color: white"
          v-for="(item,index) in objData.settingList">
        <div class="flex flex-1  p-v-15" style="flex-direction: column">
          <div class="flex a-center j-center" style="height: 100%">
            <Input v-model:value="item.name" style="width: 300px"></Input>
            <Button @click="onUpClick(index)" class="m-l-20">上移</Button>
            <Button @click="onDownClick(index)" class="m-l-20">下移</Button>
            <RadioGroup
              class="m-l-20"
              v-model="item.isShow"
              @on-change="showStatusChange(item)"
              :style="{visibility:item.type !== 1 && item.type!==2?'visible':'hidden'}">
              <Radio :label="1" class="">显示</Radio>
              <Radio :label="0" class="">隐藏</Radio>
            </RadioGroup>
          </div>
        </div>
      </li>
    </ul>

    <div class="w-full flex j-center p-v-10 bg-white" slot="footer">
      <Button @click="cancel" style="width: 100px">取消</Button>
      <Button @click="ok" style="margin-left: 50px;width: 100px" type="primary">确定
      </Button>
    </div>

  </Modal>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'ConsultEditModal',
  components: {},
  props: {
    // 点击确认
    onOk: Function,
    // 点击取消
    onCancel: Function,
  },
  data () {
    return {
      id: 0,
      name: '',
      isEnable: false,
      //显示隐藏
      modalShowHide: false,
      //咨询对象
      objData: {
        type: Object,
        default: {
          id: 0,
          name: '',
          isEnable: false,
          settingList: [],
        }
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {

    },

    /**
     * 显示弹框
     */
    show (id) {
      this.id = id
      this.getConsultDetail(id).then(res => {
        if (res.code === 0) {
          if (res.data){
            this.objData = res.data
            this.name = res.data.name || ''
            this.isEnable = res.data.isEnable || false
            this.modalShowHide = true
          }
        }
      })
    },

    /**
     * 隐藏弹框
     */
    hide () {
      this.modalShowHide = false
    },

    /**
     * 隐藏时,清空数据
     */
    onHidden () {

    },
    /**
     * 点击确认
     */
    ok () {
      let params = {
        name: this.name,
        isEnable: this.isEnable,
      }
      this.objData.settingList.forEach((item, index) => {
        item.sort = index + 1
      })
      params.settingList = this.objData.settingList
      let id = this.id
      this.editConsultDetail({id, params}).then(res => {
        if (res.code === 0) {
          this.hide()
          if (this.onOk){
            this.$nextTick(() => {
              this.onOk()
            })
          }
        }else{
          this.$Message.info(res.msg)
        }
      })
    },

    /**
     * 点击取消
     */
    cancel () {
      this.hide()
    },

    onUpClick (index) {
      if (index > 0) {
        let item = this.objData.settingList[index - 1]
        this.objData.settingList.splice(index - 1, 1)
        this.objData.settingList.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.objData.settingList.length - 1)) {
        let item = this.objData.settingList[index + 1]
        this.objData.settingList.splice(index + 1, 1)
        this.objData.settingList.splice(index, 0, item)
      }
    },

    /**
     * 至少选择一项
     */
    showStatusChange (item) {
      let datalist = this.objData.settingList
      let allHide = true
      for (let i = 0; i < datalist.length; i++) {
        if (datalist[i].isShow === 1) {
          allHide = false
          break
        }
      }
      if (allHide) {
        this.$Message.info('至少显示一项')
        setTimeout(() => {
          item.isShow = 1
        }, 100)
      }
    },

    ...mapActions([
      'getConsultDetail',
      'editConsultDetail',
    ])
  }
}
</script>

<style lang="scss" scoped>
.hoverstyle {
  &:hover {
    .showdel {
      display: block;
    }
  }

  .showdel {
    display: none;
  }
}

.modal-setting ::v-deep {

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

</style>
<style scoped>
.prewmodal >>> .ivu-modal-body {
  padding: 0;
}
</style>
